<template>
  <div
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    class="modal fade previewer"
    id="pdf_preview"
    role="dialog"
    tabindex="-1"
    data-keyboard="false"
  >
    <div class="modal-dialog" role="document">
      <div class="viewer">
        <div class="viewer-toolbar">
          <div class="dropdown pull-left mobile-menu">
            <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
              <i class="iconfont icon-list"></i>
            </a>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
              <li v-show="dialogStatus != 'create' && showDownload">
                <a @click="downloadPreviewData">
                  <i class="ti-download"></i>下载
                </a>
              </li>
              <li v-show="showShare">
                <a @click="handlePreviewData('share')">
                  <i class="iconfont icon-share"></i>分享
                </a>
              </li>
              <li v-show="showMoveCopy">
                <a @click="handlePreviewData('move')">
                  <i class="iconfont icon-move"></i>移动
                </a>
              </li>

              <li v-show="showMoveCopy">
                <a @click="handlePreviewData('copy')">
                  <i class="iconfont icon-copy"></i>复制
                </a>
              </li>
              <li v-show="showDelete">
                <a @click="deletePreviewData">
                  <i class="iconfont icon-trash"></i>删除
                </a>
              </li>
              <li v-show="dialogStatus === 'edit' || dialogStatus === 'create'">
                <a @click="saveFile">
                  <i
                    class="fa fa-cloud-upload"
                    :class="[uploading ? 'uploading' : '']"
                  ></i
                  >保存
                </a>
              </li>
            </ul>
          </div>

          <div class="pull-left menu tool">
            <a
              @click="downloadPreviewData"
              v-show="dialogStatus != 'create' && showDownload"
              data-toggle="tooltip"
              data-placement="bottom"
              title="下载"
            >
              <i class="ti-download"></i>
            </a>
            <a
              @click="handlePreviewData('share')"
              v-show="showShare"
              data-toggle="tooltip"
              data-placement="bottom"
              title="分享"
            >
              <i class="iconfont icon-share"></i>
            </a>
            <a
              @click="handlePreviewData('move')"
              v-show="showMoveCopy"
              data-toggle="tooltip"
              data-placement="bottom"
              title="移动"
            >
              <i class="iconfont icon-move"></i>
            </a>
            <a
              @click="handlePreviewData('copy')"
              v-show="showMoveCopy"
              data-toggle="tooltip"
              data-placement="bottom"
              title="复制"
            >
              <i class="iconfont icon-copy"></i>
            </a>
            <a
              @click="deletePreviewData"
              v-show="showDelete"
              data-toggle="tooltip"
              data-placement="bottom"
              title="删除"
            >
              <i class="iconfont icon-trash"></i>
            </a>
            <a
              v-show="dialogStatus === 'edit' || dialogStatus === 'create'"
              @click="saveFile"
              data-toggle="tooltip"
              data-placement="bottom"
              title="保存"
            >
              <i
                class="fa fa-cloud-upload"
                :class="[uploading ? 'uploading' : '']"
              ></i>
            </a>
          </div>

          <div class="pull-right tool">
            <a
              @click="close"
              data-toggle="tooltip"
              data-placement="bottom"
              title="关闭"
            >
              <i class="iconfont icon-close"></i>
            </a>
          </div>

          <div class="cont">
            <div class="name">
              <h4>
                {{ detail.name }}.{{ detail.file_ext }}（{{
                  textMap[dialogStatus]
                }}）
              </h4>
            </div>
          </div>
        </div>
        <div class="viewer-body">
          <div class="loadingbox" v-show="loading">
            <section class="loading Animation1">
              <section class="shape shape-1"></section>
              <section class="shape shape-2"></section>
              <section class="shape shape-3"></section>
              <section class="shape shape-4"></section>
            </section>
            <h4>正在加载，请稍后……</h4>
          </div>
          <!-- <iframe
            :src="preview_path"
            v-show="!loading"
            frameborder="0"
            width="100%"
            height="100%"
          ></iframe> -->
          <PDFViewer
            ref="pdfViewer"
            :url="preview_path"
            :dialogStatus="dialogStatus"
            :detail="detail"
            :app_save_folder_number="app_save_folder_number"
            @toggleUploading="toggleUploading"
            @updateCreateToEditStatus="updateCreateToEditStatus"
            @updateEditToCreateStatus="updateEditToCreateStatus"
            @changeVersion="changeVersion"
            @saveFile="saveFile"
            v-if="preview_path"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { preview, download } from "@/api/drive/drive";
import {
  sharePreview,
  shareDownload,
  linkTargetPreview,
  linkTargetDownload,
} from "@/api/share/share";
import { getRolePermissions } from "@/utils/permission";

export default {
  name: "pdfPreview",
  props: {
    dialogStatus: {
      type: String,
      default: "view",
    },
    detail: {
      type: Object,
    },
    linkShareNumber: {
      type: String,
    },
    app_save_folder_number: {
      type: String,
      default: null,
    },
  },
  components: {
    PDFViewer: () => import("./PDFViewer.vue"),
  },
  data() {
    return {
      uploading: false,
      loading: true,
      textMap: {
        view: "预览",
        edit: "编辑",
        create: "创建",
      },
      preview_path: "",
      category: "",
      is_preview: "",
    };
  },
  computed: {
    showShare() {
      return (
        (["file", "star"].indexOf(this.$store.state.drive.tab) > -1 &&
          this.$route.name !== "sharelink" &&
          this.$route.name !== "sendlink" &&
          this.dialogStatus != "create") ||
        (this.$route.name === "pdf" && this.dialogStatus != "create")
      );
    },
    showMoveCopy() {
      return (
        (["file", "star"].indexOf(this.$store.state.drive.tab) > -1 &&
          this.$route.name !== "sharelink" &&
          this.$route.name !== "sendlink" &&
          this.dialogStatus != "create") ||
        (this.$route.name === "pdf" && this.dialogStatus != "create")
      );
    },
    showDownload() {
      if (
        (["file", "star"].indexOf(this.tab) > -1 &&
          this.$route.name !== "sharelink" &&
          this.$route.name !== "sendlink") ||
        this.$route.name === "pdf"
      ) {
        return true;
      } else if (this.showOnGroupFile) {
        if (this.permissions.resource_operations === "ALL") {
          return true;
        }
        if (this.detail.number && this.detail.parent_number) {
          let number = this.detail.number;
          if (this.detail.parent_number != "0") {
            if (this.detail.parent_path_number) {
              number = this.detail.parent_path_number.slice(1, 37);
            } else {
              // 创建文件夹时，直接给权限
              return true;
            }
          }
          let resource = this.permissions.resource_operations.find((item) => {
            return item.folder_id === number;
          });
          if (resource) {
            let permissions = getRolePermissions(resource.role_type);
            return permissions.indexOf("downloadResource") > -1;
          }
          return false;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    showDelete() {
      if (
        (["file", "star"].indexOf(this.tab) > -1 &&
          this.$route.name !== "sharelink" &&
          this.$route.name !== "sendlink") ||
        this.$route.name === "pdf"
      ) {
        return true;
      } else if (this.showOnGroupFile) {
        if (this.permissions.resource_operations === "ALL") {
          return true;
        }
        if (this.detail.number && this.detail.parent_number) {
          let number = this.detail.number;
          if (this.detail.parent_number != "0") {
            if (this.detail.parent_path_number) {
              number = this.detail.parent_path_number.slice(1, 37);
            } else {
              // 创建文件夹时，直接给权限
              return true;
            }
          }
          let resource = this.permissions.resource_operations.find((item) => {
            return item.folder_id === number;
          });
          if (resource) {
            let permissions = getRolePermissions(resource.role_type);
            return permissions.indexOf("deleteResource") > -1;
          }
          return false;
        } else {
          return false;
        }
      }
      return false;
    },
    groupNumber() {
      return this.$store.state.drive.groupNumber;
    },
    shareNumber() {
      return this.$store.state.drive.share.share_number;
    },
    tab() {
      return this.$store.state.drive.tab;
    },
    showOnGroupFile: function () {
      return this.tab === "group-file" || this.tab === "groupdisk-file";
    },
    permissions() {
      return this.$store.state.group.permissions;
    },
  },
  methods: {
    // 浏览器关闭时进行用户提示
    beforeunloadHandler(e) {
      e = e || window.event;
      // 兼容IE8和Firefox 4之前的版本
      if (e) {
        e.returnValue = "您是否确认离开此页面-该页面数据可能不会被保存";
      }
      // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      return "您是否确认离开此页面-该页面数据可能不会被保存";
    },
    updateCreateToEditStatus(file) {
      this.$emit("updateCreateToEditStatus", file);
    },
    updateEditToCreateStatus(file) {
      this.$emit("updateEditToCreateStatus", file);
    },
    // 修改文件版本号
    changeVersion(version) {
      this.$emit("changeVersion", version);
    },
    saveFile() {
      if (this.uploading) {
        return false;
      }
      this.uploading = true;
      this.$refs.pdfViewer.uploadPdf();
    },
    toggleUploading(uploading) {
      this.uploading = uploading;
    },
    deletePreviewData() {
      this.$confirm({
        type: "confirm",
        content: `确定删除吗？`,
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          this.$store.commit("operationFileOrFolderData", {
            group_number: this.groupNumber,
            action: this.showOnGroupFile ? "delete" : "recycle",
            disk_type: "cloud",
            files_list: [
              {
                number: this.detail.number,
                type: this.detail.type,
              },
            ],
          });
          this.$store
            .dispatch("handleFileOrFolder", this.detail)
            .then((res) => {
              if (res.status_code === 200) {
                this.$emit("deletePreviewData", this.detail);
                this.close();
                this.$message({
                  type: "success",
                  message: res.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        })
        .catch(() => {});
    },
    handlePreviewData(action) {
      this.close();
      this.$emit("handlePreviewData", {
        type: "pdf",
        action: action,
        data: this.detail,
      });
    },
    loaded() {
      this.loading = false;
    },
    close() {
      if (this.dialogStatus === "edit" || this.dialogStatus === "create") {
        this.$confirm({
          type: "confirm",
          content: `当前处于编辑状态，确定关闭吗？`,
          showCancleBtn: true,
          showYesBtn: true,
          custom: [],
        })
          .then(() => {
            $("#pdf_preview").modal("hide");
          })
          .catch(() => {});
      } else {
        $("#pdf_preview").modal("hide");
      }
    },
    // 发布预览
    sendPreview() {
      this.loading = true;
      linkTargetPreview({
        link_number: this.linkShareNumber,
        link_resource_number: this.detail.number,
        link_constraint: {
          password: Cookies.get(this.linkShareNumber),
        },
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.loading = false;
            this.preview_path = res.entity.preview_path;
            this.category = res.entity.category;
            this.is_preview = res.entity.is_preview;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 分享预览
    sharePreview() {
      this.loading = true;
      let share_constraint, share_number;
      if (this.$route.name === "sharelink") {
        share_number = this.linkShareNumber;
        share_constraint = {
          password: Cookies.get(this.linkShareNumber),
        };
      } else {
        share_number = this.shareNumber;
        share_constraint = null;
      }
      sharePreview({
        share_number: share_number,
        share_resource_number: this.detail.number,
        share_constraint: share_constraint,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.loading = false;
            this.preview_path = res.entity.preview_path;
            this.category = res.entity.category;
            this.is_preview = res.entity.is_preview;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    edit() {
      this.preview();
    },
    // 云盘预览
    preview() {
      if (!this.detail.number) {
        this.loading = false;
        this.preview_path = "create";
        return false;
      }
      this.loading = true;
      preview({
        number: this.detail.number,
        group_number: this.groupNumber,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.loading = false;
            // this.preview_path = `${
            //   window.location.origin
            // }/pdfjs/web/viewer.html?file=${encodeURIComponent(
            //   res.entity.preview_path
            // )}`;
            this.preview_path = res.entity.preview_path;
            this.category = res.entity.category;
            this.is_preview = res.entity.is_preview;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    /**
     * 使用download下载的3个地方
     * 1、云盘: route:recdrive, tab:[file, star, sharefile]
     * 2、群盘: route:group, tab:[groupdisk-file]
     * 3、个人中心: route:persona, tab:[persona-file]
     * 4、应用：route:[ppt, word, excel, images, videos]
     * 5、发布资源： route:group,tab:[groupdisk-send]
     * 使用shareDownload下载的4个地方
     * 1、云盘: route:recdrive, tab:[shareme]
     * 2、群盘: route:group, tab:[groupdisk-share, groupdisk-send]
     * 3、个人中心: route:persona, tab:[persona-sharefile]
     * 4、分享链接: route:sharelink
     */
    downloadPreviewData() {
      switch (this.$route.name) {
        case "recdrive":
          if (
            ["file", "star", "sharefile"].indexOf(this.$store.state.drive.tab) >
            -1
          ) {
            this.download();
          } else if ("shareme" === this.$store.state.drive.tab) {
            this.shareDownload();
          }
          break;
        case "groupdisk":
          if (["groupdisk-file"].indexOf(this.$store.state.drive.tab) > -1) {
            this.download();
          } else if (
            ["groupdisk-share", "groupdisk-send"].indexOf(
              this.$store.state.drive.tab
            ) > -1
          ) {
            this.shareDownload();
          }
          break;
        case "persona":
          if ("persona-file" === this.$store.state.drive.tab) {
            this.download();
          } else if ("persona-sharefile" === this.$store.state.drive.tab) {
            this.shareDownload();
          }
          break;
        case "sharelink":
          this.shareDownload();
          break;
        case "sendlink":
          this.sendDownload();
          break;
        default:
          // route:[ppt, word, excel, images, videos]
          this.download();
          break;
      }
    },
    // 云盘资源下载
    download() {
      let params = {
        files_list: [this.detail.number],
        group_number: this.groupNumber,
      };
      download(params)
        .then((res) => {
          if (res.status_code === 200) {
            window.location.href =
              res.entity[this.detail.number] + "&download=download";
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 分享资源下载
    shareDownload() {
      let params = {
        share_resources_list: [this.detail.number],
      };
      if (this.$route.name === "sharelink") {
        params.share_number = this.linkShareNumber;
        params.share_constraint = {
          password: Cookies.get(this.linkShareNumber),
        };
      } else {
        params.share_number = this.shareNumber;
      }
      shareDownload(params)
        .then((res) => {
          if (res.status_code === 200) {
            window.location.href =
              res.entity[this.detail.number] + "&download=download";
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 发布资源下载
    sendDownload() {
      let params = {
        link_number: this.linkShareNumber,
        link_constraint: {
          ip: null,
          host: null,
          password: Cookies.get(this.linkShareNumber),
        },
        link_resources_list: [this.detail.number],
      };
      linkTargetDownload(params)
        .then((res) => {
          if (res.status_code === 200) {
            window.location.href =
              res.entity[this.detail.number] + "&download=download";
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
  mounted() {
    $("#pdf_preview").on("show.bs.modal", () => {
      this.$emit("changePreviewStatus", true);
      if (this.$route.name === "sendlink") {
        this.sendPreview();
      } else if (
        (this.shareNumber && this.tab != "sharefile") ||
        this.$route.name === "sharelink"
      ) {
        this.sharePreview();
      } else {
        if (this.dialogStatus === "edit" || this.dialogStatus === "create") {
          this.edit();
          // 当进入编辑界面时，添加关闭浏览器提示
          window.onbeforeunload = this.beforeunloadHandler;
        } else if (this.dialogStatus === "view") {
          this.preview();
        }
      }
    });
    $("#pdf_preview").on("hidden.bs.modal", () => {
      this.preview_path = null;
      this.uploading = false;
      this.$emit("changePreviewStatus", false);
      // this.$emit("getInfo");

      if (this.dialogStatus === "edit" || this.dialogStatus === "create") {
        window.onbeforeunload = null;
      }
    });
  },
  destroyed() {
    $("#pdf_preview").off();
  },
};
</script>

<style scoped>
.loadingbox {
  position: relative; /*脱离文档流*/
  top: 25%;
}
.fa-cloud-upload {
  color: #777;
  padding-top: 4px;
  font-size: 17px;
}
.uploading {
  cursor: unset;
  color: #006adf !important;
  animation-name: beat;
  /*动画名称*/
  animation-duration: 0.5s;
  /*设置秒数*/
  animation-timing-function: linear;
  /*速度曲线*/
  animation-iteration-count: infinite;
  /*播放次数*/
  animation-direction: alternate;
  /*逆向播放*/
  animation-play-state: running;
}
@keyframes beat {
  0% {
    padding-top: 5px;
  }

  100% {
    padding-top: 3px;
  }
}
</style>